const DAY_MS = 24 * 60 * 60 * 1000;

export const WINDOW_OPTIONS = [
  { label: '24h', days: 1 },
  { label: '7d', days: 7 },
  { label: '30d', days: 30 },
];

/** ISO from/to range covering the last `days` days ending now. */
export function windowRange(days) {
  const to = new Date();
  const from = new Date(to.getTime() - days * DAY_MS);
  return { from: from.toISOString(), to: to.toISOString() };
}

/** Human label for a day count, falling back to `${days}d`. */
export function windowLabel(days) {
  return WINDOW_OPTIONS.find((option) => option.days === days)?.label || `${days}d`;
}
